import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add1",
  "use": "icon-add1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-add1\"><defs><style type=\"text/css\"></style></defs><path d=\"M35.2 539.2C20 539.2 8 527.2 8 512s12-27.2 27.2-27.2h954.4c15.2 0 27.2 12 27.2 27.2s-12 27.2-27.2 27.2H35.2z\" fill=\"\" p-id=\"1953\" /><path d=\"M512 1016c-15.2 0-27.2-12-27.2-27.2V35.2C484.8 20 496.8 8 512 8s27.2 12 27.2 27.2v954.4c0 14.4-12 26.4-27.2 26.4z\" fill=\"\" p-id=\"1954\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol